<template>
    <div id="myDateShow">
        <div class="title">{{merchants.id?"修改":"新增"}} 农基商资料</div>
        <div id="dataShow">
            <div class="line">
                <div class="key">农基商类型</div>
                <div class="value">
                    <el-select class="w500" v-model="merchants.merchantsClassify" placeholder="请选择农基商类型">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="line">
                <div class="key">农基商名称</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.merchantsName" placeholder="请填写农基商名称"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">联系人</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.name" placeholder="请填写农基商联系人"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">常用邮箱</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.email" placeholder="请填写农基商联系人常用邮箱"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">联系地址</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.address" placeholder=" 请填写联系地址"></el-input>
                </div>
            </div>
            <div class="line">
                <div class="key">农基区域</div>
                <div class="value" @click="addClick">
                    <el-cascader class="w500"
                                 v-model="merchants.detailAddress"
                                 :props="cityArrProp"
                                 :options="cityArr"
                                 placeholder="请选择农基区域"></el-cascader>
                </div>
            </div>
            <div class="line">
                <div class="key">合作协议书</div>
                <div class="value">
                    {{merchants.agreementName}}
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-upload
                            :headers="headers"
                            ref="upload"
                            :on-change="upLoad"
                            :on-success="upLoadSeccess"
                            class="upload-demo"
                            name="multipartFile"
                            drag
                            :action="baseURL+'/merchants/upload'"
                            :auto-upload="false">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">重新提交协议书</div>
                    </el-upload>
                </div>
            </div>
            <div class="line">
                <div class="key">绑定结算方式</div>
                <div class="value">
                    <el-radio-group @change="changeSettlementType" v-model="merchants.settlementType">
                        <el-radio-button label="Personal">个人收款</el-radio-button>
                        <el-radio-button label="Merchant">商户收款</el-radio-button>
                        <el-radio-button label="Reference">引荐人收款</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Personal'">
                <div class="key">收款人真实姓名</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.personalPayeeName" placeholder="请填写收款人真实姓名"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Personal'">
                <div class="key">收款人常用手机号码</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.personalPayeeMobile"
                              placeholder="请填写收款人常用手机号码"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Personal'">
                <div class="key">个人身份证照片</div>
                <div class="value" style="display: inline-flex;">
                    <el-upload
                            :headers="headers"
                            ref="PayeeIDCardFront"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.PayeeIDCardFront"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.payeeIDCardFront" :src="merchants.payeeIDCardFront.url"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传身份证正面照片</div>
                    </el-upload>
                    <el-upload
                            :headers="headers"
                            ref="PayeeIDCardOpposite"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.PayeeIDCardOpposite"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.payeeIDCardOpposite" :src="merchants.payeeIDCardOpposite.url"
                             class="avatar">
                        <i v-if="merchants.payeeIDCardOpposite==null" class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传身份证国徽面照片</div>
                    </el-upload>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Personal'">
                <div class="key">个人收款码</div>
                <div class="value" style="display: inline-flex;">
                    <el-upload
                            :headers="headers"
                            ref="WeiXinPersonalPayeeCode"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.WeiXinPersonalPayeeCode"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.weiXinPersonalPayeeCode!=null"
                             :src="merchants.weiXinPersonalPayeeCode.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传个人微信收款码</div>
                    </el-upload>
                    <el-upload
                            :headers="headers"
                            ref="ZhiFuBaoPersonalPayeeCode"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.ZhiFuBaoPersonalPayeeCode"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.zhiFuBaoPersonalPayeeCode!=null"
                             :src="merchants.zhiFuBaoPersonalPayeeCode.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传个人支付宝收款码</div>
                    </el-upload>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">商户机构名称</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.merchantOrganizationName"
                              placeholder="请填写商户机构名称"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">商户社会统一信用代码</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.merchantCreditCode"
                              placeholder="请填写商户社会统一信用代码"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">商户营业执照</div>
                <div class="value" style="display: inline-flex;">
                    <el-upload
                            :headers="headers"
                            ref="MerchantBusinessLicense"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.MerchantBusinessLicense"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.merchantBusinessLicense!=null"
                             :src="merchants.merchantBusinessLicense.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传营业执照</div>
                    </el-upload>
                    <el-upload
                            :headers="headers"
                            ref="MerchantOtherQualificationsLicense"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.MerchantOtherQualificationsLicense"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.merchantOtherQualificationsLicense!=null"
                             :src="merchants.merchantOtherQualificationsLicense.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传许可证或其他资质照片</div>
                    </el-upload>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">上传商户收款码</div>
                <div class="value" style="display: inline-flex;">
                    <el-upload
                            :headers="headers"
                            ref="WeiXinMerchantPayeeCode"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.WeiXinMerchantPayeeCode"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.weiXinMerchantPayeeCode!=null"
                             :src="merchants.weiXinMerchantPayeeCode.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传商户小微收款码</div>
                    </el-upload>
                    <el-upload
                            :headers="headers"
                            ref="ZhiFuBaoMerchantPayeeCode"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.ZhiFuBaoMerchantPayeeCode"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.zhiFuBaoMerchantPayeeCode!=null"
                             :src="merchants.zhiFuBaoMerchantPayeeCode.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传商户支付宝收款码</div>
                    </el-upload>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">商户开户网点</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.merchantAccountOpeningBranch"
                              placeholder="请填写商户开户网点"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">商户账号</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.merchantAccount" placeholder="请填写商户账号"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Merchant'">
                <div class="key">结算银行卡号</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.merchantBankCard" placeholder="请填写结算银行卡号"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Reference'">
                <div class="key">引荐人真实姓名</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.referencePayeeName" placeholder="请填写引荐人真实姓名"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Reference'">
                <div class="key">引荐人常用手机号码</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.referencePayeeMobile"
                              placeholder="请填写引荐人常用手机号码"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Reference'">
                <div class="key">引荐人联系地址</div>
                <div class="value">
                    <el-input class="w500" v-model="merchants.referenceContactAddress"
                              placeholder="请填写引荐人联系地址"></el-input>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Reference'">
                <div class="key">引荐人身份证</div>
                <div class="value" style="display: inline-flex;">
                    <el-upload
                            :headers="headers"
                            ref="PayeeReferenceIDCardFront"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.PayeeReferenceIDCardFront"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.payeeReferenceIDCardFront!=null"
                             :src="merchants.payeeReferenceIDCardFront.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传身份证正面照片</div>
                    </el-upload>
                    <el-upload
                            :headers="headers"
                            ref="PayeeReferenceIDCardOpposite"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.PayeeReferenceIDCardOpposite"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.payeeReferenceIDCardOpposite && merchants.payeeReferenceIDCardOpposite!=null"
                             :src="merchants.payeeReferenceIDCardOpposite.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传身份证国徽面照片</div>
                    </el-upload>
                </div>
            </div>
            <div class="line" v-if="merchants.settlementType=='Reference'">
                <div class="key">引荐人收款码</div>
                <div class="value" style="display: inline-flex;">
                    <el-upload
                            :headers="headers"
                            ref="WeiXinReferencePayeeCode"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.WeiXinReferencePayeeCode"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.weiXinReferencePayeeCode!=null"
                             :src="merchants.weiXinReferencePayeeCode.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传引荐人微信收款码</div>
                    </el-upload>
                    <el-upload
                            :headers="headers"
                            ref="ZhiFuBaoReferencePayeeCode"
                            :on-progress="progress"
                            :on-change="upLoad"
                            :on-success="handleDocumentSuccess"
                            :limit="1"
                            class="upload-demo"
                            name="multipartFile"
                            :data="uploadParam.ZhiFuBaoReferencePayeeCode"
                            :action="baseURL+'/system/uploadFile'"
                            :show-file-list="false"
                            accept=".jpg,.png,.jpeg">
                        <img v-if="merchants.zhiFuBaoReferencePayeeCode!=null"
                             :src="merchants.zhiFuBaoReferencePayeeCode.url" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <div slot="tip" class="el-upload__tip">请上传引荐人支付宝收款码</div>
                    </el-upload>
                </div>
            </div>
            <div class="line">
                <div class="key"></div>
                <div class="value">
                    <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
                </div>
            </div>
            <div class="line"></div>
        </div>
        <div class="but">
            <el-button type="danger" size="small" @click="backClick">返回</el-button>
        </div>
    </div>
</template>

<script>
    import {getMerchantsById, newVue, updateMerchants} from "../../network/merchants";
    import {City, getOneLeave, getTwoLeave} from "../../network/city";

    export default {
        name: "MerchantsInsert",
        data() {
            return {
                merchants: {},
                merchantsId: '',
                options: [
                    {
                        value: "自营农基商",
                        label: "自营农基商"
                    },
                    {
                        value: "第三方农基商",
                        label: "第三方农基商"
                    }
                ],
                cityArr: [],
                cityArrProp: {
                    lazy: true,
                    lazyLoad(node, resolve) {
                        setTimeout(() => {
                            if (node.data != null) {
                                getTwoLeave(node.data.id).then(res => {
                                    if (res.data.length != 0) {
                                        let cityA = [];
                                        for (let i = 0; i < res.data.length; i++) {
                                            let cityItem = new City(res.data[i]);
                                            cityA.push(cityItem)
                                        }
                                        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                                        resolve(cityA);
                                    } else {
                                        resolve();
                                    }
                                })
                            }
                        }, 0);
                    }
                },
                authorization: "",
                headers: {},
                baseURL: newVue.baseURL,
                uploadParam: {
                    PayeeIDCardFront: {type: "PayeeIDCardFront"},
                    PayeeReferenceIDCardFront: {type: "PayeeReferenceIDCardFront"},
                    PayeeIDCardOpposite: {type: "PayeeIDCardOpposite"},
                    PayeeReferenceIDCardOpposite: {type: "PayeeReferenceIDCardOpposite"},
                    WeiXinPersonalPayeeCode: {type: "WeiXinPersonalPayeeCode"},
                    ZhiFuBaoPersonalPayeeCode: {type: "ZhiFuBaoPersonalPayeeCode"},
                    WeiXinMerchantPayeeCode: {type: "WeiXinMerchantPayeeCode"},
                    ZhiFuBaoMerchantPayeeCode: {type: "ZhiFuBaoMerchantPayeeCode"},
                    MerchantBusinessLicense: {type: "MerchantBusinessLicense"},
                    MerchantOtherQualificationsLicense: {type: "MerchantOtherQualificationsLicense"},
                    WeiXinReferencePayeeCode: {type: "WeiXinReferencePayeeCode"},
                    ZhiFuBaoReferencePayeeCode: {type: "ZhiFuBaoReferencePayeeCode"},
                },
                loadingMsg: null,
            }
        },
        created() {
            newVue.obj = this;
            this.authorization = newVue.obj.common.loginInfo.jwtToken;
            this.headers.Authorization = this.authorization;
            this.common.HeaderLocationTwo.href = "/merchants/list";
            this.common.HeaderLocationTwo.name = "农基商资料管理";
            this.common.HeaderLocationThree.name = "新增or修改农基商列表";
            if (this.$route.params.id != null) {
                this.merchantsId = this.$route.params.id;
                getMerchantsById(this.merchantsId).then(res => {
                    this.merchants = res.data;
                })
            } else {
                this.merchants.settlementType = "Personal";
            }
            this.$forceUpdate();
        },
        methods: {
            upLoadSeccess(res) {
                this.merchants.agreementUrl = res.data;
            },
            backClick() {
                this.$router.push("../list");
            },
            addClick() {
                getOneLeave().then(res => {
                    for (let i = 0; i < res.data.length; i++) {
                        let cityItem = new City(res.data[i]);
                        this.cityArr.push(cityItem)
                    }
                    this.cityArr.splice(0, 1)
                })
            },
            upLoad(file, fileList) {
                this.merchants.agreementName = file.name.split(".")[0];
                this.$refs.upload.submit();
            },
            submit() {
                updateMerchants(this.merchants).then(res => {
                })
            },
            handleDocumentSuccess(res, file) {

                let item = {};
                item["name"] = file.name;
                item["id"] = file.uid;
                item["fileSize"] = file.raw.size;
                item["fileType"] = file.raw.type;
                item["associationType"] = file.response.data.associationType;
                item["url"] = file.response.data.url;
                item["imageUrl"] = URL.createObjectURL(file.raw);

                if (file.response != null) {
                    switch (file.response.data.associationType) {
                        case "PayeeIDCardFront":
                            this.merchants.payeeIDCardFront = item;
                            break;
                        case "PayeeReferenceIDCardFront":
                            this.merchants.payeeReferenceIDCardFront = item;
                            break;
                        case "PayeeIDCardOpposite":
                            this.merchants.payeeIDCardOpposite = item;
                            break;
                        case "PayeeReferenceIDCardOpposite":
                            this.merchants.payeeReferenceIDCardOpposite = item;
                            break;
                        case "WeiXinPersonalPayeeCode":
                            this.merchants.weiXinPersonalPayeeCode = item;
                            break;
                        case "ZhiFuBaoPersonalPayeeCode":
                            this.merchants.zhiFuBaoPersonalPayeeCode = item;
                            break;
                        case "WeiXinMerchantPayeeCode":
                            this.merchants.weiXinMerchantPayeeCode = item;
                            break;
                        case "ZhiFuBaoMerchantPayeeCode":
                            this.merchants.zhiFuBaoMerchantPayeeCode = item;
                            break;
                        case "MerchantBusinessLicense":
                            this.merchants.merchantBusinessLicense = item;
                            break;
                        case "MerchantOtherQualificationsLicense":
                            this.merchants.merchantOtherQualificationsLicense = item;
                            break;
                        case "WeiXinReferencePayeeCode":
                            this.merchants.weiXinReferencePayeeCode = item;
                            break;
                            break;
                        case "ZhiFuBaoReferencePayeeCode":
                            this.merchants.zhiFuBaoReferencePayeeCode = item;
                            break;

                    }
                }
                console.log(this.merchants);
                if (this.loadingMsg != null) {
                    this.loadingMsg.close();
                }
                this.$forceUpdate();
            },
            progress() {
                this.loadingMsg = this.$loading({
                    lock: true,
                    text: '正在上传中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            },
            upLoadDocument(file, fileList) {
                this.$refs.upload.submit();
            },
            changeSettlementType(value) {//改变绑定结算方式
                this.$forceUpdate();
            }
        }
    }
</script>

<style scoped>
    @import "../../assets/css/data.css";

    .w500 {
        width: 500px;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
